'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _GameScoreCard = require('../GameScoreCard');

var _GameScoreCard2 = _interopRequireDefault(_GameScoreCard);

var _Ticker = require('../Ticker');

var _Ticker2 = _interopRequireDefault(_Ticker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScoreTicker = function ScoreTicker(props) {
  var scoreTickerTrack = function scoreTickerTrack(type, data) {
    if (props.trackEvent) {
      props.trackEvent('score_ticker_' + type, data);
    }
  };
  return _react2.default.createElement(
    _Ticker2.default,
    { trackEvent: scoreTickerTrack, height: '72px' },
    props.games.map(function (game) {
      return _react2.default.createElement(_GameScoreCard2.default, _extends({ key: game.boxscoreUrl, trackEvent: scoreTickerTrack }, game));
    })
  );
};

ScoreTicker.propTypes = {
  games: _propTypes2.default.arrayOf(_propTypes2.default.shape(_GameScoreCard2.default.propTypes)).isRequired,
  trackEvent: _propTypes2.default.func // eslint-disable-line react/no-unused-prop-types
};

ScoreTicker.defaultProps = {
  trackEvent: null
};

exports.default = ScoreTicker;